const T = 20, E = 16, _ = 80;
export {
  E as DEFAULT_FONT_SIZE,
  T as DEFAULT_LINE_HEIGHT,
  _ as DEFAULT_TEXT_WIDTH
};
